export enum MessageType {
  AllClients = 1,
  SpecificClient = 2,
  Product = 3,
  ProductVersion = 4,
  Intermediary = 5,
}
